import React from "react";
import "./loading.css";
import load_gif from "./loading.gif";

const LoadSpinner = ({ visible, text = "Carregando..." }) => {
  if (!visible) return null;

  return (
    <div className="spinner-overlay">
      <div className="spinner-content">
        <img
          src={load_gif}
          alt="Carregando"
          className="spinner-image"
        />
        <span className="spinner-text">{text}</span>
      </div>
    </div>
  );
};

export default LoadSpinner;
